import React from 'react';

import {useLanguageDirection} from 'coreHooks';

import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import Flyout from 'brandComponents/Flyout';
import {EFlyoutDirections} from 'brandComponents/Flyout/IFlyout';
import InTheMoodForTile from 'brandComponents/InTheMoodFor/InTheMoodForTile';

import styles from './InTheMoodForFlyout.module.scss';

const InTheMoodForFlyout = () => {
	const {ITMFData} = useCategoryContext(true) || {};
	const isRTL = useLanguageDirection().direction === 'rtl';

	if (!ITMFData) {
		console.error('No ITMF Data found');

		return;
	}

	return (
		<Flyout
			id="inTheMoodFor"
			flyoutClassName={styles['itmf-flyout']}
			showCloseButton
			softLock
			contentClassName={styles['itmf-flyout__content']}
			closeClassName={styles['itmf-flyout__close']}
			direction={isRTL ? EFlyoutDirections.RIGHT_TO_LEFT : EFlyoutDirections.LEFT_TO_RIGHT}
			className={styles['itmf']}
		>
			<div className={styles['itmf-flyout__title']}>
				{ITMFData.title}
			</div>
			<div className={styles['itmf-flyout__subitems']}>
				{ITMFData.subItems.map((subItem, i) => (
					<InTheMoodForTile
						className={styles['itmf-flyout__subitem']}
						categoryId={subItem.category}
						image={subItem.image}
						hoverImg={subItem.hoverImg}
						title={subItem.title}
						key={`${i}-${subItem.category}`}
					/>
				))}
			</div>
		</Flyout>
	);
};

export default InTheMoodForFlyout;

